module.exports = __webpack_public_path__ + "a21a4824da0b5476e933f009e192a37e.svg";